import type { ComponentStyleConfig } from "@chakra-ui/react";

export const ButtonTheme: ComponentStyleConfig = {
  baseStyle: {
    fontFamily: "heading",
    borderRadius: 2,
    fontWeight: "medium",
    width: "fit-content",
  },
  variants: {
    solid: {
      bg: "brand.red.100",
      color: "brand.white.100",
      _hover: {
        bg: "brand.red.110",
      },
      _active: {
        bg: "brand.red.110",
      },
      _disabled: {
        pointerEvents: "none",
        opacity: 1,
        bg: "brand.red.50",
      },
      boxShadow: "0px 10px 20px #00000029",
    },
    outline: {
      bg: "transparent",
      borderColor: "brand.red.100",
      color: "brand.red.100",
      fontWeight: "regular",
      _hover: {
        bg: "transparent",
        borderColor: "brand.red.110",
        color: "brand.red.110",
      },
      _disabled: {
        borderColor: "brand.black.90",
        color: "brand.black.90",
        _hover: {
          borderColor: "brand.black.90",
          color: "brand.black.90",
        },
      },
      _focusWithin: {
        bg: "transparent",
      },
    },
    link: {
      color: "brand.royalblue.100",
      _hover: {
        color: "brand.skyblue.100",
      },
    },
    banner: {
      bg: "yellow.100",
      color: "yellow.500",
      _hover: {
        bg: "yellow.500",
        color: "yellow.100",
      },
    }
  },
  defaultProps: {
    bg: "brand.red.100",
  },
};
